import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/apiClient";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Key } from "@phosphor-icons/react";

export default function ChangePasswordDialog({ open, onClose }) {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const reset = () => { setCur(""); setNw(""); setConfirm(""); };

  const submit = async (e) => {
    e.preventDefault();
    if (nw !== confirm) return toast.error("Konfirmasi password tidak cocok");
    if (nw.length < 6) return toast.error("Password baru minimal 6 karakter");
    setSubmitting(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password berhasil diubah");
      reset(); onClose();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && (reset(), onClose())}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-heading text-lg flex items-center gap-2">
            <Key size={20} weight="duotone" className="text-sky-600" /> Ganti Password
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} data-testid="pw-form" className="space-y-3 mt-2">
          <div>
            <label className="text-[11px] font-bold uppercase tracking-[0.1em] text-slate-600">Password Saat Ini</label>
            <Input data-testid="pw-current" type="password" value={cur} onChange={(e) => setCur(e.target.value)} required autoFocus className="mt-1.5" />
          </div>
          <div>
            <label className="text-[11px] font-bold uppercase tracking-[0.1em] text-slate-600">Password Baru</label>
            <Input data-testid="pw-new" type="password" value={nw} onChange={(e) => setNw(e.target.value)} required minLength={6} className="mt-1.5" placeholder="Minimal 6 karakter" />
          </div>
          <div>
            <label className="text-[11px] font-bold uppercase tracking-[0.1em] text-slate-600">Konfirmasi Password Baru</label>
            <Input data-testid="pw-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required className="mt-1.5" />
          </div>
          <div className="flex justify-end gap-2 pt-1">
            <Button type="button" variant="outline" onClick={() => { reset(); onClose(); }}>Batal</Button>
            <Button type="submit" disabled={submitting} data-testid="pw-submit" className="bg-slate-900 hover:bg-slate-800 text-white">
              {submitting ? "Menyimpan…" : "Ubah Password"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
